import { CSVProfile, CSVTranformationProfile, IDataPoint } from '../../types'

import { BaseVisualization } from '../base/base-visualization-component'
import { NumberDeltaData } from '@meltwater/mw-visualizations-angularjs'
import { TRANSFORM_ROUND_DECIMAL } from '../commons/constants'
import round from 'lodash/round'
import angular from 'angular'
import isNumber from 'lodash/isNumber'
import isUndefined from 'lodash/isUndefined'
import isNil from 'lodash/isNil'

export class NumberDeltaComponent extends BaseVisualization {
 static config = {
  selector: 'afNumberDelta',
  controller: NumberDeltaComponent,
  template: `
        <span>
            <mw-number-delta
                ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty($ctrl.visualizationData)"
                data="$ctrl.visualizationData"
                chart-options="$ctrl.visualizationOptions"
                get-api="$ctrl.getApi(API)">
            </mw-number-delta>
            <md-tooltip>
                {{$ctrl.visualizationData.number | number}}
            </md-tooltip>
        </span>

        <div>
            <span class="af__dateRange" ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty($ctrl.visualizationData) && $ctrl.dateRange && !$ctrl.visualizationData.isDeltaNaN">
            <span translate>{{$ctrl.dateRangeName()}}</span>
            </span>
        </div>
    `,
  bindings: BaseVisualization.config.bindings,
 }

 // default CSV header columns. Can be overriden in sub class.
 public csvHeaders = ['Category', 'Count']
 public transformationProfiles: CSVTranformationProfile[] = [
  { key: 'value', type: TRANSFORM_ROUND_DECIMAL },
 ]

 $onChanges(changes) {
  if (this.hasChanges(changes.visualizationMetaData)) {
   this.setMetaData(changes.visualizationMetaData.currentValue)
  }
  if (changes.vizData && typeof changes.vizData.currentValue !== 'undefined') {
   if (!this.isObjEmpty(changes.vizData.currentValue.data)) {
    this.setProperties()
    this.updateData(changes.vizData.currentValue.data.all)
    this.buildCSVExportProfile()
   } else {
    this.visualizationData = {}
   }
  }
 }

 setProperties() {}

 updateData(data: IDataPoint[]) {
  let numberDelta = {}

  if (!isUndefined(data[1]) && !isNil(data[1]) && !isNaN(Number(data[1].value)) && isNumber(data[1].value)) {
   numberDelta = {
    number: data[0].value,
    delta: data[1].value,
   }
  } else {
   numberDelta = {
    number: data[0].value,
   }
  }

  this.visualizationData = new NumberDeltaData(numberDelta)
 }

 exportCSV() {
  // overview data
  let exportData: any = {}
  angular.copy(this.vizData.data, exportData)

  exportData.all[1].value = round(exportData.all[1].value, 2).toFixed(2)

  //   this.csvOptions.title = this.visTitle
  //   this.csvOptions.headers = ['Category', 'Count']
  //   this.csvExporter.options = this.csvOptions
  //   this.csvExporter.generateCsvFromArrayObject([exportData])
 }

 buildCSVExportProfile() {
  this.csvExportProfiles = []
  let exportData: CSVProfile = {
   data: Object.assign({}, this.vizData.data),
   csvOptions: { title: this.visTitle, headers: this.csvHeaders },
   transformationProfiles: this.transformationProfiles,
  }

  this.csvExportProfiles.push(exportData)
 }
}
